// 景观景点
<template>
  <el-card>
    <el-form inline ref="searchInfo" :model="info">
      <el-form-item prop="projectId">
        <el-select v-model="info.projectId" @change="change" placeholder="请选择公园名称" clearable filterable>
          <el-option v-for="(item, index) in parkList" :key="index" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="source">
        <el-select v-model="info.source" @change="change" placeholder="请选择评价类目" filterable clearable>
          <el-option v-for="item in evaluateList" :key="item.source" :label="item.sourceName"
            :value="item.source"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="obejctId">
        <el-select v-model="info.obejctId" placeholder="请选择评价对象" filterable clearable>
          <el-option v-for="item in objectList" :key="item.obejctId" :label="item.obejctName"
            :value="item.obejctId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table class="global-table" v-loading="loading" :data="tableData">
      <el-table-column label="评价对象" show-overflow-tooltip prop="obejctName"></el-table-column>
      <el-table-column label="评价类目" show-overflow-tooltip prop="sourceName"></el-table-column>
      <el-table-column label="所属公园" show-overflow-tooltip prop="projectName"></el-table-column>
      <el-table-column label="评论数量" show-overflow-tooltip prop="evaluateCount"></el-table-column>
      <el-table-column label="未读评论数量" show-overflow-tooltip prop="unReadEvaluateCount"></el-table-column>
      <el-table-column label="点赞数量" show-overflow-tooltip prop="praiseCount"></el-table-column>
      <el-table-column label="操作" width="110px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" @click="onDetail(row.obejctId)">查看评论</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
      :page-size.sync="size" :total="total">
    </GlobalPagination>
  </el-card>
</template>

<script>
import keepAlive from '@/mixins/keepAlive.js'
export default {
  name: 'Evaluate',
  mixins: [keepAlive],
  data() {
    return {
      evaluateList: [],
      objectList: [],
      info: {
        projectId: this.$route.query.projectId || '',
        source: '',
        obejctId: ''
      },
      loading: false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      parkList: []
    }
  },
  created() {
    this.getEvaluateList()
    this.loadData()
    this.getPark()
  },
  methods: {
    // 获取公园列表
    getPark() {
      this.$axios.get(this.$apis.project.selectYhProjectByPage, {
        projectType: '4',
        page: 1,
        size: 100,
        isCad: 0
      }).then(res => {
        this.parkList = res.list || []
      })
    },
    // 获取评价类目
    getEvaluateList() {
      this.$axios.get(this.$apis.tourist.selectSourceList).then(res => {
        this.evaluateList = res || []
      })
    },
    // 评价对象
    change() {
      this.objectList = this.evaluateList.filter(item => { return item.source === this.info.source })
      this.objectList = this.objectList[0] ? this.objectList[0].objectList : []
      if (this.info.projectId) {
        this.objectList = this.objectList.filter(item => { return item.projectId === this.info.projectId })
      }
      this.info.obejctId = ''
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.tourist.selectTouristEvaluateSumByPage, {
          ...this.info,
          page: this.page,
          size: this.size,
          orderPraiseCount: this.$route.query.orderPraiseCount || ''
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onDetail(id) {
      this.$router.push({
        name: 'EvaluateDetail',
        params: { id }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>
